import moment from "moment"

interface Props {
  startTime?: BigInt
}

const ProjectDate = ({ startTime }: Props) => {
  const startDate = startTime ? moment.unix(parseInt(startTime.toString())) : null
  if (!startDate) return null

  return (
    <p className="gallery-label text-gallery-muted">
      {startDate.isBefore() ? "Launched" : "Opening"} {startDate.format("LL")}
    </p>
  )
}

export default ProjectDate
